
import { defineComponent } from "vue";

import EnrollmentCollectionContent from "./components/EnrollmentCollectionContent.vue";

export default defineComponent({
  name: "EnrollmentPage",
  components: {
    EnrollmentCollectionContent
  },
});
